﻿export class SystemNotification {
    systemNotificationId: number;
}